import * as next from '../../../types/next'
import type { PaymentMethod } from '../../../utils'
import { CONTROL_NAME } from '../../../utils'
import type { UpBlockHandler } from '../types'

import { upCommonSettings } from './common'

export const up: UpBlockHandler<next.PaymentMethodBlock> = (uischema) => {
  if (uischema.type !== CONTROL_NAME.PAYMENT_CONTROL) {
    throw new Error('Expected a valid PaymentMethod control')
  }

  return {
    type: next.BLOCK_TYPE.PAYMENT_METHOD,
    settings: {
      ...upCommonSettings(uischema),
      inputUIPattern: uischema.options?.uiType,
      preselectedMethod: uischema.options?.initialType,
      implementations: upPaymentMethodImplementations(
        uischema.options?.implementations
      )
    }
  }
}

/**
 * This is needed because the configurator types are not well defined, but do
 * effectively have this.
 */
type PaymentMethodWithShow = PaymentMethod & { show?: boolean }

function upPaymentMethodImplementations(
  implementations: PaymentMethodWithShow[]
) {
  return implementations.reduce<next.AnyPaymentMethod[]>((acc, item) => {
    if (item.show !== false) {
      switch (item.type) {
        case 'SEPA':
        case 'payment_sepa':
          acc.push({
            type: next.PAYMENT_METHOD.SEPA,
            label: item.label,
            settings: {
              fieldLabels: {
                accountOwner: item.componentProps?.accountOwnerNameLabel,
                bankName: item.componentProps?.bankNameLabel,
                consentLabel: item.componentProps?.consentLabel
              },
              accountNumberValidationURL: item.componentProps!.apiBaseUrl
            }
          })
          break

        case 'BankTransfer':
        case 'payment_invoice':
          acc.push({
            type: next.PAYMENT_METHOD.BANK_TRANSFER,
            label: item.label
          })

          break

        default:
          throw new Error(`Unsupported payment method type: ${item.type}`)
      }
    }

    return acc
  }, [])
}
